import { Checkbox } from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'

const CheckboxAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const handleChange = (event) => {
    input.onChange(event.target?.checked)
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
      event_name: FPTI_EVENTS.FORM.FIELD_PRESSED,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
        event_name: FPTI_EVENTS.FORM.VALIDATION_ERROR,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <Checkbox
      {...rest}
      onChange={handleChange}
      error={meta.touched ? !!meta.error : false}
      errorText={meta.touched ? meta.error : ''}
    />
  )
}

export default CheckboxAdapter
